import { ChevronRight, PhoneIncoming } from 'lucide-react';
import { useSoftphone } from '@/store/softphone';
import { ActiveCallCard } from '@/components/softphone/ActiveCallCard';
import { QueueActionOverlay } from '@/components/softphone/QueueActionOverlay';

/**
 * Aktif Çağrılar sayfası.
 *  - Aktif çağrı varsa → ActiveCallCard ortalanmış olarak render
 *  - Yoksa → boş durum ipucu
 *
 * Faz 4'te müşteri kartı + scripter + müşteri geçmişi tab'ları
 * (ROADMAP'teki "Aktif Çağrılar" tasarımı) eklenecek.
 */
export default function ActiveCalls() {
  const { state, call, queueAction } = useSoftphone();
  const inCall = state === 'in_call' || state === 'calling' || state === 'ringing';
  const showQueueOverlay = queueAction !== null;

  return (
    <div className="p-6 h-full flex flex-col">
      <header className="mb-4 flex-shrink-0">
        <h1 className="text-[22px] font-semibold tracking-tight text-slate-900 leading-tight">Aktif Çağrılar</h1>
        <div className="text-[11.5px] text-slate-400 mt-1 flex items-center gap-1.5">
          <span>Müşteri Temsilcisi</span>
          <ChevronRight size={11} className="opacity-60" />
          <span>Aktif Çağrılar</span>
        </div>
      </header>

      <div className="flex-1 flex items-center justify-center min-h-0">
        {showQueueOverlay ? (
          <section className="h-full w-full max-w-[460px] bg-slate-50 rounded-2xl ring-1 ring-black/5 overflow-hidden">
            <QueueActionOverlay />
          </section>
        ) : inCall && call ? (
          <section className="h-full w-full max-w-[480px] bg-slate-50 rounded-2xl ring-1 ring-black/5 overflow-hidden">
            <ActiveCallCard />
          </section>
        ) : (
          <EmptyState />
        )}
      </div>
    </div>
  );
}

function EmptyState() {
  return (
    <div className="text-center max-w-md">
      <div className="w-20 h-20 rounded-3xl bg-slate-100 text-slate-400 flex items-center justify-center mx-auto mb-4">
        <PhoneIncoming size={36} strokeWidth={1.5} />
      </div>
      <h2 className="text-base font-semibold text-slate-700 tracking-tight">Aktif çağrı yok</h2>
      <p className="text-[12.5px] text-slate-500 mt-1.5">
        Çağrı geldiğinde otomatik olarak bu sayfaya yönlendirilirsin. Bekleyene kadar
        Hızlı Arama'dan giden çağrı yapabilirsin.
      </p>
    </div>
  );
}
